module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUAQMAAADWX60MAAAABlBMVEULUIn/wQALm62UAAAAFklEQVQI12NgsGEAAsLEfyBAJ4jUCwDa0ROx9tu+uQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/se.png
// module id = 378
// module chunks = 0